
import BaseFilter from '@/components/filters/Filter';
import SelectPicker from '@/components/SelectPicker.vue';

export default BaseFilter.extend({
	components: {
		SelectPicker
	},
	props: {
		value: {
			type: Array as () => string[],
			required: true,
			default: () => []
		},
	},
});

